export const VerticalDitributeIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path
        d="M1.33301 14.6654V13.332H14.6663V14.6654H1.33301ZM4.66634 8.9987V6.9987H11.333V8.9987H4.66634ZM1.33301 2.66536V1.33203H14.6663V2.66536H1.33301Z"
        fill="#1A2547"
      />
    </svg>
  );
};
